import actions from "./actions";

const proofCategoryModule = {
  state: {},
  mutations: {},
  actions,
  getters: {},
};

export default proofCategoryModule;
